import { defineStore } from 'pinia';
import { useToggle } from '@vueuse/core';
import { watch } from 'vue';
import { useStorage } from '@/storage/index';

export const STORE_ID = 'app-sidebar';

export const useAppSidebarStore = defineStore(STORE_ID, () => {
    const { get, set } = useStorage('app-sidebar-collapsed');

    const [collapsed, toggle] = useToggle(get(false));

    watch(collapsed, newValue => set(newValue));

    return {
        collapsed,
        toggle: () => toggle(),
    };
});
